import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";

var ContentFooter = function ContentFooter(props) {
  var background = props.background,
      className = props.className,
      direction = props.direction,
      divider = props.divider,
      end = props.end,
      padding = props.padding,
      reverse = props.reverse,
      start = props.start,
      remaining = _objectWithoutProperties(props, ["background", "className", "direction", "divider", "end", "padding", "reverse", "start"]);

  var getDirection = function getDirection() {
    if (direction === 'horizontal') {
      if (reverse) {
        return 'row-reverse';
      }

      return 'row';
    } else {
      if (reverse) {
        return 'column-reverse';
      }

      return 'column';
    }
  };

  var getPadding = function getPadding() {
    if (start) {
      if (getDirection() === 'row') {
        return {
          left: 16
        };
      } else if (getDirection() === 'row-reverse') {
        return {
          right: 16
        };
      } else if (getDirection() === 'column') {
        return {
          top: 12
        };
      } else if (getDirection() === 'column-reverse') {
        return {
          bottom: 12
        };
      }
    }
  };

  var startBox = /*#__PURE__*/React.createElement(Box, {
    className: "ContentFooter-start",
    flex: {
      alignItems: start && start.alignItems || 'center',
      justifyContent: start && start.justifyContent || 'flex-start'
    },
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1
  }, start && start.content);
  var endBox = /*#__PURE__*/React.createElement(Box, {
    className: "ContentFooter-end",
    flex: {
      alignItems: end && end.alignItems || 'center',
      justifyContent: end && end.justifyContent || 'flex-start'
    },
    flexBasis: "auto",
    flexGrow: 0,
    flexShrink: 0,
    padding: getPadding()
  }, end && end.content);
  var classes = classNames('ContentFooter', className);
  return /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    className: classes,
    background: background,
    divider: divider ? {
      color: 'light',
      side: 'top',
      width: 1
    } : null,
    flex: {
      alignItems: 'stretch',
      direction: getDirection(),
      justifyContent: 'flex-end'
    },
    padding: padding !== undefined ? padding : {
      horizontal: 20,
      vertical: 16
    }
  }), start && start.content && startBox, end && end.content && endBox);
};

ContentFooter.defaultProps = {
  background: 'white',
  direction: 'horizontal',
  divider: false
};
export default ContentFooter;